export default {
  "code": "en",
  "title": "English",
  "flag": "🇺🇸",
  "meta": {
    "index": {
      "title": "Better research papers,\n10x faster with AI",
      "description": "Access millions of scientific sources & generate\ntop tier texts, including accurate citations."
    },
    "profile": {
      "title": "Profile Settings",
      "description": "Easily control your profile settings"
    }
  },
  "templates": {
    "summarize-text": {
      "headline": "",
      "description": ""
    },
    "find-topic": {
      "headline": "Find Topic",
      "description": "Brainstorming to get more ideas for a research paper topic."
    },
    "find-sources": {
      "headline": "Find Sources",
      "description": "Search for academic sources that could be relevant to the topic."
    },
    "source-qa": {
      "headline": "Source Q&A",
      "description": "Answer questions about a source. Add a link to a website, an online document, or upload a file from your computer."
    },
    "write-outline": {
      "headline": "Create Outline",
      "description": "Create a rough outline for a research paper topic."
    },
    "write-introduction": {
      "headline": "Write Introduction",
      "description": "Create an introduction for a research paper."
    },
    "write-chapter": {
      "headline": "Write Chapter",
      "description": "Write a chapter for a research paper."
    },
    "write-essay": {
      "headline": "Write Essay",
      "description": "Write a complete research paper."
    },
    "proofreading": {
      "headline": "Proofreading",
      "description": "Correct a text."
    },
    "freestyle": {
      "headline": "Freestyle",
      "description": "Write any text."
    },
    "summarize-document": {
      "headline": "",
      "description": ""
    },
    "summarize-article": {
      "headline": "",
      "description": ""
    },
    "summarize-source": {
      "headline": "",
      "description": ""
    }
  },
  "validations": {
    "required": "{_field_} is a required field",
    "min": "{_field_} must be at least {length} characters long",
    "max": "{_field_} must not be longer than {length} characters"
  },
  "tools": {
    "findSources": "Find Sources",
    "writeOutline": "Create Outline",
    "writeChapter": "Write Chapter",
    "writeEssay": "Write Essay"
  },
  "buttons": {
    "close": "Close",
    "upgrade": "upgrade",
    "get_more_words": "Get more words now",
    "login": "login",
    "logout": "logout",
    "cancel": "Cancel",
    "yes": "Yes",
    "no": "No",
    "tryout": "try out",
    "add": "add",
    "report": "report",
    "save": "save",
    "edit": "edit",
    "discard": "discard",
    "done": "done",
    "copy": "copy",
    "delete": "delete",
    "generate": "generate",
    "signup": "sign up",
    "continue": "continue",
    "submit": "send",
    "add_source": "Add Source",
    "select_source": "Select Source",
    "new_document": "New Document",
    "back": "back",
    "local_document": {
      "title": "PDF document from my computer",
      "type": "Upload PDF document"
    },
    "web_document": {
      "title": "Weblink, e.g. Wikipedia",
      "type": "Add weblink"
    },
    "ask": "Ask",
    "flag": "Flag"
  },
  "labels": {
    "features": "Features",
    "missing_subscription": "You need a subscription to use this tool.",
    "booked": "your current plan",
    "account": "Account",
    "subscription": "Subscription",
    "name": "Name",
    "email": "Email",
    "limit": "Limit",
    "settings": "Settings",
    "words": "Words",
    "usage": "Usage",
    "extra_words": "including {words} extra words",
    "show_all_applications": "Show all applications",
    "show_all": "Show all",
    "start_page": "Go to start page",
    "is_favorite": "In favorites",
    "add_favorite": "Add to favorites",
    "wordlimit_reached": "Word limit reached",
    "wordlimit_increase": "Increase word limit now",
    "contact": "Open contact",
    "history": "History",
    "show_history": "show history",
    "inprint": "Imprint",
    "dataregulation": "Data regulation",
    "tos": "Terms of Service",
    "month": "month",
    "monthly": "Monthly",
    "year": "year",
    "yearly": "Yearly",
    "save_50": "save 50%",
    "cancel_anytime": "Cancel anytime",
    "pay_amount_per_period": "Pay {amount}/{period}.",
    "try_now": "try now for free",
    "book_again": "Book again",
    "book": "Change plan",
    "upgrade_to": "Upgrade to {product}",
    "copied_link": "Link copied",
    "subject": "Subject",
    "generated_by_hesse": "Generated by Hesse in 3 seconds.",
    "use_template": "use template",
    "show_mode": "show more",
    "upload": "upload",
    "optional": "optional",
    "my_documents": "My Documents",
    "my_sources": "My Sources",
    "add_source": "Add Source",
    "select_source": "Select Source",
    "page": "Page {page}",
    "pages": "Pages {from} - {to}",
    "unknown_author": "Unknown author",
    "checker_results": "AI checker results",
    "human": "human",
    "citation_style": "Citation style",
    "started_at": "started at",
    "ends_at": "ends at",
    "cancel_subscription": "cancel subscription",
    "file_too_large": "File too large (max. 50 MB), try splitting it",
    "relevance": "Relevance",
    "relevance_help": "Relevance measures how well the source fits the searched topic in terms of content.",
    "quality": "Quality",
    "quality_help": "Quality measures how good the source is both in content and form.",
    "trustworthiness": "Trustworthiness",
    "trustworthiness_help": "Trustworthiness measures, mainly based on the source's metadata, how reliable it is.",
    "high": "high",
    "normal": "normal",
    "low": "low",
    "focus_of_the_chapter": "Focus of the chapter",
    "reason": "Reason",
    "summary": "Summary",
    "raw_text": "Raw Text",
    "topic": "Topic",
    "essay_banner_part_1": "🚨 <i>This feature will be disabled soon</i><br/>For <strong>better generation results</strong> and <strong>more fine-grained control</strong>, we recommend using the",
    "essay_banner_part_2": "tool and to generate your essay <strong>chapter by chapter</strong>. Try it out for a smoother, more tailored writing experience! ✨📖",
    "language": "Language",
    "language_english_hint": "Many academic papers are published in English. We recommend also searching for English sources to find more relevant results.",
    "length": "Length",
    "length_options": [
      {
        "text": "short (4 paragraphs)",
        "value": "short"
      },
      {
        "text": "normal (6 paragraphs)",
        "value": "normal"
      },
      {
        "text": "long (8 paragraphs)",
        "value": "long"
      }
    ],
    "source_type_options": [
      {
        "label": "Automatic source research",
        "value": "quality"
      },
      {
        "label": "Work with your own sources",
        "value": "quality_with_sources"
      }
    ],
    "sources": "Sources",
    "source": "Source",
    "open_access": "Open Access",
    "show_only_open_access": "Show Only Open Access Sources",
    "essay_outline_options": [
      {
        "label": "Generate an outline for me",
        "value": "generate"
      },
      {
        "label": "Use my own outline",
        "value": "provide"
      }
    ],
    "your_outline": "Your Outline",
    "outline": "Outline",
    "year_of_publication": "Year of publication",
    "summary_type": "Type of summary",
    "summary_type_options": [
      {
        "label": "Informative",
        "value": "informative"
      },
      {
        "label": "Descriptive",
        "value": "descriptive"
      },
      {
        "label": "Critical",
        "value": "critical"
      },
      {
        "label": "Abstract",
        "value": "abstract"
      }
    ],
    "original_text": "Original text",
    "maintenance": "Our services are under maintenance for a little while. Sorry for the inconvenience and thanks for your understanding!",
    "something_wrong": "Always check citations carefully. Something wrong?",
    "bad_citation_title": "Report citation",
    "bad_citation_text": "Please tell us what you think is wrong with the highlighted citation.",
    "thanks_for_report": "Thank you for helping us make Hesse AI better!",
    "no_sources_found": "No sources found. Try adjusting your topic or search filters.",
    "user_instruction": "Custom instructions",
    "document": "Document",
    "article": "Article",
    "study_program": "Study Program",
    "study_subject": "Subject",
    "interests": "Interests",
    "used_for_source_search": "Used for source search",
    "not_used_for_source_search": "Not used for source search",
    "headline": "Focus of the chapter",
    "chapter_length": "Length",
    "chapter_length_options": [
      {
        "text": "short (4 paragraphs)",
        "value": "short"
      },
      {
        "text": "normal (6 paragraphs)",
        "value": "normal"
      },
      {
        "text": "long (8 paragraphs)",
        "value": "long"
      }
    ],
    "source_chat_placeholder": "Summarize this source for me...",
    "publish_year": "Year of publication",
    "text": "Original text",
    "prompt": "Instruction"
  },
  "stages": {
    "searching_sources": "Searching sources",
    "filtering_sources": "Filtering sources",
    "processing_sources": "Processing sources",
    "writing_plan": "Creating writing plan",
    "writing_chapter": "Writing chapter"
  },
  "blog": {
    "written_by": "Written by",
    "read_article": "Read article"
  },
  "source": {
    "select": {
      "empty": {
        "headline": "Nothing here yet.",
        "hint": "You can bookmark sources in 'Find Sources' and use them in various tools."
      }
    },
    "table": {
      "name": "Name",
      "type": "Type",
      "created_at": "Created at"
    },
    "type": {
      "document": "Document",
      "website": "Article",
      "paper": "Paper"
    },
    "snippet": {
      "hint": "The text from the original document may be strangely formatted. In most cases, this is not a problem for the AI. But we are working on improving this."
    },
    "hint": {
      "not_usable": "Sources that are not yet processed are not considered when writing."
    },
    "processing": "being processed...",
    "recent": "recently used",
    "bookmark": "bookmark",
    "bookmarked": "bookmarked",
    "direct_pdf_access": "Direct PDF access",
    "source_info": "Source info"
  },
  "placeholders": {
    "url": "https://www.nature.com/articles/s41586-023-06447-0",
    "topic": "Sustainable Urban Development: Smart Cities between Innovation and Social Justice",
    "focus_of_the_chapter_legacy": "Digital Transformation",
    "focus_of_the_chapter": "How would you title your chapter?",
    "outline": "I. The Evolution of Smart Cities\n   A. From traditional to connected cities\n      1. Definition and core concepts\n      2. Technological drivers of development\n   B. Sustainability as central paradigm\n      1. Environmental monitoring and protection\n      2. Resource optimization through IoT\nII. Social dimensions of digitalization\n   A. Inclusion and accessibility\n   B. Citizen data sovereignty\n   C. Overcoming digital divide",
    "original_text": "Quantum physics revolutionizes our understanding of reality at the most fundamental level.\nUnlike classical physics, where particles are either particles or waves, quantum mechanics shows that matter can have both properties simultaneously.\nThe famous double-slit experiment demonstrates this duality impressively: individual photons create an interference pattern as if they were going through both slits at the same time.\nQuantum entanglement, described by Einstein as 'spooky action at a distance', allows particles to remain instantaneously connected over large distances.\nThese phenomena form the basis for revolutionary technologies such as quantum computers and quantum cryptography...",
    "chat": "What practical applications arise from this?",
    "report_citation": "This citation is inaccurate because...",
    "user_instruction": "Analyze the impact of digitalization on traditional craft professions and show solution approaches",
    "topic_placeholder": "Artificial Intelligence in Education: Opportunities and Challenges",
    "outline_placeholder": "I. Introduction to AI-supported education\n   A. Definition and fundamentals\n      1. What is AI in educational context?\n      2. Current developments and trends\n   B. Potentials for personalized learning\n      1. Adaptive learning systems\n      2. Individual support\nII. Challenges and ethical considerations\n   A. Data protection and privacy\n   B. Digital divide and accessibility",
    "document_placeholder": "Research_AI_Education.pdf",
    "article_placeholder": "https://www.nature.com/articles/s41586-023-06259-2",
    "study_program_placeholder": "Digital Education & Media Pedagogy",
    "study_subject_placeholder": "Digital Humanities",
    "interests_placeholder": "Sustainability, Blockchain, Creative Economy",
    "headline_placeholder": "AI-supported learning platforms",
    "source_chat_placeholder": "Summarize this source for me...",
    "random_text_placeholder": "The future of work is facing a revolutionary change through the integration of artificial intelligence and automation technologies.\nWhile traditional jobs are being replaced by robots and AI systems, completely new professional fields and career opportunities are emerging simultaneously.\nThe ability for continuous further education and adaptation to new technologies is becoming a key competence in the modern working world.\nRemote work and flexible working models are gaining importance and fundamentally changing how we define collaboration and productivity.\nCompanies must increasingly deal with questions of digital ethics, data protection and the balance between efficiency and human value creation..."
  },
  "groups": {
    "research": "Research",
    "essay": "Essay",
    "misc_tools": "Other Tools"
  },
  "flows": {
    "summarize": {
      "headline": "Summarize",
      "description": "What would you like to summarize?"
    },
    "titles": {
      "summarize_document": "Document",
      "summarize_text": "Text",
      "summarize_article": "Article",
      "summarize_source": "Source"
    },
    "prefill": {
      "summarize_document": "Summarize the content of this document for me."
    }
  },
  "messages": {
    "get_more_words": "Get more words now",
    "contact_success": "Thank you for your message!",
    "error": "Something didn't work. Please try again later.",
    "updated": "{field} updated",
    "failed_to_update": "Could not update \"{field}\", please try again",
    "generic_error": "Your request failed – try again later or contact support 😔",
    "upload_error_generic": "We couldn't process one of your sources – please replace it or use our automatic sources",
    "upload_error_url": "We couldn't process the provided URL – if it's a PDF, try uploading it directly as a file",
    "upload_error_high_no_content": "We couldn't extract enough relevant information from one of your sources – please replace it or use our automatic sources",
    "no_snippets_found_error": "Couldn't find enough sources for the provided data – please retry with different inputs",
    "account_deletion_error": "Deleting account is not possible while you have an active subscription. Please unsubscribe first."
  },
  "validation": {
    "required": "{_field_} is required",
    "min": "{_field_} must be at least {length} characters long",
    "max": "{_field_} must not be longer than {length} characters",
    "maxarray": "{_field_} has too many elements"
  },
  "domains": {
    "cancellation": {
      "headline": "Cancel subscription",
      "description": "Do you really want to cancel your subscription? For what reason do you want to cancel?",
      "options": [
        {
          "text": "Work completed",
          "value": "work_completed"
        },
        {
          "text": "Not satisfied with the product",
          "value": "unsatisfied_with_product"
        },
        {
          "text": "Too expensive",
          "value": "price_performance_issue"
        },
        {
          "text": "Technical issues",
          "value": "technical_issues"
        },
        {
          "text": "Found another provider",
          "value": "found_other_provider"
        },
        {
          "text": "I was unaware it was a subscription",
          "value": "unaware_of_subscription"
        },
        {
          "text": "Other",
          "value": "other"
        }
      ]
    },
    "try": {
      "headline": "Hesse Pro",
      "loading": "We are activating your test account..."
    },
    "openai": {
      "status": {
        "unreliable": "We currently have increased server load. There may be outages. If something doesn't work, please try again later.",
        "working_on_fix": "There may currently be outages. We are already working on a solution. Please try again later."
      }
    },
    "ai_checker": {
      "hint": "AI checkers are tools that check texts for AI content. You can click on the cards to go to the corresponding tool."
    },
    "cookie": {
      "headline": "Cookies 🍪",
      "text1": "When you click on \"Accept All Cookies\", you agree to the storage of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.",
      "analytics": "Performance Cookies",
      "analytics_text": "These cookies allow us to analyze user behavior on Hesse.ai anonymously to optimize the user experience.",
      "marketing_text": "These cookies can be set by our advertising partners through our website. They may be used by those companies to build a profile of your interests and show you relevant ads on other sites.",
      "marketing": "Marketing Cookies",
      "technical": "Functional Cookies",
      "technical_text": "These cookies are necessary to ensure secure and reliable use.",
      "consent": "Accept All Cookies",
      "save": "Save Preferences",
      "decline": "Decline"
    },
    "write": {
      "save_changes": "Save changes",
      "keep_writing": "Keep writing"
    },
    "feedback": {
      "title": "Give us additional feedback",
      "description": "We are constantly trying to improve our results. Please describe what you would like to have changed."
    },
    "report": {
      "title": "Report this answer?",
      "reason": "Reason for reporting",
      "description": "Report results that contain critical or illegal content.",
      "result_good": "Result is helpful",
      "result_bad": "Result is not helpful"
    },
    "pricing": {
      "monthly_wordlimit": "{limit} words per month",
      "increase_limit": "Increase limit",
      "wordlimit_reached": "You have reached your word limit",
      "wordlimit_reached_description": "The quota for this month has been exhausted. If you want to continue, you need to increase your limit.",
      "wordlimit_nearly_reached": "Your words are nearly used up.",
      "get_more_words": "Get more words",
      "get_more_words_description": "High-quality texts require a lot of computing power. That's expensive.<br /> But we have made our packages as affordable as possible.",
      "error_title": "The booking unfortunately did not work.",
      "error_description": "Contact us - We will help immediately.",
      "text1": "How much is 10,000 words?",
      "text2": "That was 10,000 words",
      "referral_title": "Can't decide yet?",
      "referral_title2": "Need more words?",
      "referral_description": "Share your link with friends. You will receive 1,000 free words for each new sign-up through your link.",
      "upgrade_confirm": {
        "title": "Confirm upgrade",
        "message": "You are switching from {current} to {next} for {price}/month. The change takes effect immediately – the remaining time on your current plan will be credited pro-rata.",
        "confirm": "Confirm upgrade"
      }
    },
    "survey": {
      "title": "How do you rate Hesse.ai?",
      "suggestions": "What would you change?",
      "success_title": "Thank you for your feedback!",
      "success_text": "You help us continuously improve Hesse.ai",
      "abort": "do not rate"
    },
    "cards_hint": {
      "title": "Flashcards are now available",
      "subtitle": "Automatically <strong>create flashcards</strong> from your <strong>lecture</strong>?",
      "cta": "Create flashcards now"
    },
    "share_modal": {
      "headline": "Share Hesse - get free words"
    },
    "login_page": {
      "loading": "Logging you in...",
      "error": "Login was not successful",
      "delayed": "The login is taking longer than usual.<br /> Please check your internet connection and try again if necessary.",
      "try_again": "Log in again"
    },
    "sidebar": {
      "create_own_application": "Create your own application",
      "hesse_cards": "Hesse Cards 🃏",
      "all_applications": "All applications",
      "favourites": "My favorites"
    },
    "profile": {
      "title": "Profile settings",
      "limit": "Limit",
      "used_tokens": "Used tokens",
      "get_more_words": "Get more words now",
      "no_subscription": "You don't have a subscription yet.",
      "upgrade_now": "Upgrade now",
      "manage_subscription": "Manage subscription",
      "delete_account": "Delete account",
      "deleted": "Your account has been deleted. If you log in, a new account will be created."
    },
    "contact": {
      "title": "Contact",
      "subtitle": "Contact us"
    },
    "error_page": {
      "title404": "404 - Page not found",
      "title": "An error has occurred",
      "text": "Help us improve Hesse.ai.<br /> Describe briefly what you did immediately before this page appeared.",
      "cta": "Go to start page"
    },
    "success_page": {
      "loading": "loading...",
      "booking_success": "Your booking was successful!",
      "booked_product": "You have booked {productName}",
      "start_now": "Get started now"
    }
  },
  "typewriter": {
    "writeEssay": [
      "Generating texts...",
      "Encrypting texts...",
      "Plagiarism check...",
      "Running AI checker tools...",
      "Texts no longer traceable ✔"
    ],
    "writeOutline": [
      "Generating texts...",
      "Encrypting texts...",
      "Plagiarism check...",
      "Running AI checker tools...",
      "Texts no longer traceable ✔"
    ],
    "writeIntroduction": [
      "Generating texts...",
      "Encrypting texts...",
      "Plagiarism check...",
      "Running AI checker tools...",
      "Texts no longer traceable ✔"
    ]
  },
  "loader": [
    "Evaluating your inputs",
    "Adding salt and pepper",
    "Pedro, Pedro, Pedro",
    "Shaking magic wand",
    "Bringing to your table"
  ],
  "features": {
    "find-sources": {
      "headline": "Find Sources",
      "description": "Search for academic sources that could be relevant to the topic."
    },
    "write-outline": {
      "headline": "Create Outline",
      "description": "Create a rough outline for a research paper topic."
    },
    "write-chapter": {
      "headline": "Write Chapter",
      "description": "Write a chapter for a research paper."
    },
    "write-essay": {
      "headline": "Write Essay",
      "description": "Write a research paper."
    },
    "source-qa": {
      "headline": "Source Q&A",
      "description": "Answer questions about a source. Add a link to a website or upload a file from your computer."
    },
    "proofreading": {
      "headline": "Proofreading",
      "description": "Correct a text."
    }
  }
}
